import React, { useState, useEffect, useRef } from 'react';
import { API } from 'aws-amplify';
import './FollowTheBeatModule8.css';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import PopUp from '../Popup/logoutPopup';
import LottieAnimation from '../components/Lottie/LottieAnimation';
import loading from './../loading-gif-png-5.gif';
import left from './left_hand.svg'
import right from './right_hand.svg'
import ReactAnimateImages from './animation';

const FollowTheBeatModule8 = (props) => {
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const dispatch = useDispatch();
  const lottieRef = useRef()
  const [playInstructions, setPlayInstructions] = useState(false);
  const [playSong, setPlaySong] = useState(false);
  const [song, setSong] = useState(props.song);
  const [playAwesomeJob, setPlayAwesomeJob] = useState(false);
  const ref = useRef(null);
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const lizard = generateImageUrl('images/Module3Images/Lizard+closing+still+image.gif');
  const nest = generateImageUrl('images/Module8Images/Nest.png');
  const flyingDino = generateImageUrl('images/Module8Images/FlyingDino4.png');
  const coinBar = generateImageUrl('images/Images/Coin+Counter.png');
  const coin = generateImageUrl('images/Images/Coin_Empty.png');
  const flyingBird = [
    generateImageUrl('images/Module8Images/Unit2_Mod3_FTB_FlyingDino1.svg'), 
    generateImageUrl('images/Module8Images/Unit2_Mod3_FTB_FlyingDino2.svg'), 
    generateImageUrl('images/Module8Images/Unit2_Mod3_FTB_FlyingDino3.svg'), 
    generateImageUrl('images/Module8Images/Unit2_Mod3_FTB_FlyingDino4.svg'), ];

  const [coinAnimationState, setCoinAnimationState] = useState('');
  const [showCoin, setShowCoin] = useState(false);

  const [CountingGif, setCountingGif] = useState(props.count);
  const [counting, setCounting] = useState(false);

  const [awesomeJobAudio, setAwesomeJobAudio] = useState(props.awesomeJob);
  const [showAnimal, setShowAnimal] = useState(false);
  const [audioReady, setAudioReady] = useState(false);
  const [displayVoice, setDisplayVoice] = useState(false);
  const [animalVoice, setAnimalVoice] = useState('');
  const [birdFlyng, setBirdFlying] = useState(false);
  const [score, setScore] = useState(0);

  const [isOpen, setIsOpen] = useState(false);
  const [tutorial, setTutorial] = useState(props.tutorial1);
  const [lizardState, setLizardState] = useState(lizard);


  const [Exit, setExit] = useState(
    generateImageUrl('images/Images/close.png')
  );

  // Music audio refs/state
  const musicAudioRef = useRef(null);
  const expectedMusicSrcRef = useRef('');
  const musicEndActionRef = useRef(null);
  const musicOnPlayActionRef = useRef(null);
  const [musicSrc, setMusicSrc] = useState('');
  const [musicShouldPlay, setMusicShouldPlay] = useState(false);

  // Starts the application
  useEffect(() => {
    controllerStart();
  }, []);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  // Helper to programmatically play music audio
  const playMusicAudio = async (src, onEndedAction = null, onPlayAction = null, restartIfSame = true) => {
    if (src && typeof src.then === 'function') src = await src;
    const el = musicAudioRef.current;
    const currentSrc = el ? (el.currentSrc || el.src) : '';
    const same = !!currentSrc && currentSrc.includes(src);
    expectedMusicSrcRef.current = src;
    musicEndActionRef.current = onEndedAction;
    musicOnPlayActionRef.current = onPlayAction;
    if (el && same) {
      if (!restartIfSame) return;
      try { el.pause(); el.currentTime = 0; await el.play(); } catch {}
    } else {
      setMusicSrc(src);
      setMusicShouldPlay(true);
    }
  };

  const timing = [
    {
      timestamp: 0,
    },
    {
      timestamp: 1.96,
    },
    {
      timestamp: 4.98,
    },
    {
      timestamp: 7,
    },
    {
      timestamp: 9.03,
    },
    {
      timestamp: 9.85,
    },
    {
      timestamp: 12.96,
    },
    {
      timestamp: 14.95,
    },
    {
      timestamp: 16.92,
    },
    {
      timestamp: 17.95,
    },
    {
      timestamp: 20.9,
    },
    {
      timestamp: 22.91,
    },
    {
      timestamp: 24.92,
    },
    {
      timestamp: 25.9,
    },
    {
      timestamp: 28.92,
    },
    {
      timestamp: 30.97,
    },
    {
      timestamp: 32.97,
    },
    {
      timestamp: 33.9,
    },
    {
      timestamp: 36.97,
    },
    {
      timestamp: 38.94,
    },
    {
      timestamp: 40.97,
    },
    {
      timestamp: 42,
    },
    {
      timestamp: 45.02,
    },
    {
      timestamp: 47.04,
    },
    {
      timestamp: 49.07,
    },
    {
      timestamp: 50,
    },
    {
      timestamp: 53.02,
    },
    {
      timestamp: 55.04,
    },
    {
      timestamp: 57.07,
    },
    {
      timestamp: 58,
    },
    {
      timestamp: 61.02,
    },
    {
      timestamp: 63.04,
    },
    {
      timestamp: 65.07,
    },
    {
      timestamp: 66,
    },
    {
      timestamp: 69.02,
    },
    {
      timestamp: 71.04,
    },
    {
      timestamp: 73.07,
    },
    {
      timestamp: 74,
    },
    {
      timestamp: 77.02,
    },
    {
      timestamp: 79.04,
    },
    {
      timestamp: 81.07,
    },
    {
      timestamp: 82,
    },
  ];

  const [context, setContext] = useState({
    circleCount: 1,
    timingCount: 0,
    activateClickDiv: false,
    clickedOnce: false,
    showCircle1: false,
    showCircle2: false,
    showCircle3: false,
    showCircle4: false,
    timerId: 0,
    secondTimerId: 0,
    startedTutorial: false,
    finishedTutorial: false,
    startedTutorial2: false,
    finishedTutorial2: false,
  });

  // Play tutorial (music channel) when startedTutorial is set
  useEffect(() => {
    if (!context.startedTutorial) return;
    playMusicAudio(
      tutorial,
      () => {
        document.getElementsByClassName('circleDiv8')[0].style.display = 'none';
        context.secondTimerId = setTimeout(() => {
          context.activateClickDiv = true;
          context.clickedOnce = false;
          setContext({ ...context });
        }, 1000);
        if(props.unit4){
          if(tutorial !== props.tutorial1_2){
            document.getElementById('rightHand').style.display = 'block';
          }
          else{
            document.getElementById('leftHand').style.display = 'block';
          }
        }
        document.getElementsByClassName('circleDiv8')[0].style.display = 'block';
        setBirdFlying(true);
        ref.current && ref.current.handleStart && ref.current.handleStart();
        context.startedTutorial = false;
        setContext({ ...context });
      }
    );
  }, [context.startedTutorial, tutorial]);

  // Play tutorial2 (music channel) when startedTutorial2 is set
  useEffect(() => {
    if (!context.startedTutorial2) return;
    playMusicAudio(
      props.tutorial2,
      () => {
        setPlaySong(true);
      }
    );
  }, [context.startedTutorial2, props.tutorial2]);

  // Play main song (music channel) when playSong is toggled
  useEffect(() => {
    if (!playSong) return;
    playMusicAudio(
      song,
      () => {
        setPlaySong(false);
        setCounting(false);
        if (context.finishedTutorial) {
          if(props.unit3 || props.unit4){
            document.getElementById('shrugLizard').style.display= 'none';
            document.getElementsByClassName('animateLizardFollow')[0].style.display='block'
            document.getElementsByClassName('circleDiv8')[0].style.display = 'none';
            document.getElementById('rightHand').style.display = 'none';
            document.getElementById('leftHand').style.display = 'none';
          }
          setAnimalVoice(awesomeJobAudio);
          setLizardState(props.awesomeJobGIF);
          setShowAnimal(true);
          setPlayAwesomeJob(true);
        } else {
          togglePopup();
          document.getElementsByClassName('circleDiv8')[0].style.display = 'none';
          document.getElementsByClassName('circleDiv8')[1].style.display = 'none';
          document.getElementsByClassName('circleDiv8')[2].style.display = 'none';
          document.getElementsByClassName('circleDiv8')[3].style.display = 'none';
        }
      },
      () => {
        context.finishedTutorial ? StartFTB() : props.unit4 ? StartTutorial2() : ftbTutorial();
      }
    );
  }, [playSong, song]);

  const updateScore = async () => {
    try {
      await API.post('TIR', '/v3/student/result', {
        body: {
          student_id: login.studentid,
          metric: props.score,
          result: JSON.stringify({
            day: props.module.currentday,
            created: new Date().toISOString(),
            values: [{ value: score, target: 10 }],
          }),
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  async function StartFTB() {
    let count = 0;
    let round = 1;
    if(props.unit3 || props.unit4){
      document.getElementById('shrugLizard').style.display='block'
      document.getElementsByClassName('animateLizardFollow')[0].style.display='none'
    }
    for (let i = 1; i < timing.length; i++) {
      await new Promise((resolve) =>
        setTimeout(
          resolve,
          (timing[i].timestamp - timing[i - 1].timestamp) * 1000
        )
      );
      setCounting(false);
      setCountingGif(null)
      await sleep(1);
      if (count === 0) {
        setTimeout(() => {
          document.getElementsByClassName('circleDiv8')[3].style.display = 'none';
        }, 1500);
      } else {
        if (count === 1) {
          if(props.unit4){
            document.getElementById('rightHand').style.display =
            'none';
            document.getElementById('leftHand').style.display =
            'none';
          }
          context.activateClickDiv = false;
          setContext({ ...context });
        }
        document.getElementsByClassName('circleDiv8')[count - 1].style.display =
        'none';
      }

      setBirdFlying(true);
      ref.current.handleStart();
      document.getElementsByClassName('circleDiv8')[count].style.display =
        'block';
      if (count === 0) {
        if((round % 2) !== 0 && props.unit4){
          document.getElementById('rightHand').style.display =
          'block';
        }
        else if ((round % 2) === 0 && props.unit4){
          document.getElementById('leftHand').style.display =
          'block';
        }
        setTimeout(() => {
          if(!props.unit3 && !props.unit4) {
            setCountingGif(props.count)
            setCounting(true);
          }
          context.activateClickDiv = true;
          setContext({ ...context });
        }, 2000);
        setTimeout(() => {
          ref.current.handleStop();
          setBirdFlying(false);
        }, 1500);
      } else {
        setTimeout(() => {
          ref.current.handleStop();
          setBirdFlying(false);
          if(!props.unit3 && !props.unit4) {
            setCountingGif(props.count)
            setCounting(true);
          }
          else lottieRef.current.anim.goToAndPlay(0, true);
        }, 800);
      }
      count += 1;
      if (count === 4) {
        round += 1;
        count = 0;
      }
    }
    await new Promise((resolve) => setTimeout(resolve, 2 * 1000));
    document.getElementsByClassName('circleDiv8')[3].style.display = 'none';
  }

  function increaseCoins() {
    props.module.coins++;
  }

  const coinAnimation = () => {
    setCoinAnimationState('coinAnimation');
  };

  async function ftbTutorial() {
    let count = 0;
    if(props.unit3 || props.unit4){
      document.getElementById('shrugLizard').style.display='block'
      document.getElementsByClassName('animateLizardFollow')[0].style.display='none'
    }
    for (let i = 1; i < 9; i++) {
      await new Promise((resolve) =>
        setTimeout(
          resolve,
          (timing[i].timestamp - timing[i - 1].timestamp) * 1000
        )
      );
      if (count === 0) {
        setTimeout(() => {
          document.getElementsByClassName('circleDiv8')[3].style.display = 'none';
        }, 1500);
      } else {
        if (count === 1) {
          if(props.unit4){
            document.getElementById('rightHand').style.display =
            'none';
            document.getElementById('leftHand').style.display =
            'none';
          }
          context.activateClickDiv = false;
          setContext({ ...context });
        }
        document.getElementsByClassName('circleDiv8')[count - 1].style.display =
        'none';
      }
      setBirdFlying(true);
      ref.current.handleStart();
      document.getElementsByClassName('circleDiv8')[count].style.display =
        'block';
      if (count === 0) {
        setTimeout(() => {
          context.activateClickDiv = true;
          setContext({ ...context });
        }, 2000);
        setTimeout(() => {
          ref.current.handleStop();
          setBirdFlying(false);
        }, 1500);
      } else {
        setTimeout(() => {
          if(props.unit3 || props.unit4) {
            lottieRef.current.anim.goToAndPlay(0, true);
          }
          ref.current.handleStop();
          setBirdFlying(false);
        }, 800);
      }
      count += 1;
      if (count === 4) {
        count = 0;
      }
    }
  }

  async function StartTutorial2() {
    let count = 0;
    let round = 1;
    if(props.unit3 || props.unit4){
      document.getElementById('shrugLizard').style.display='block'
      document.getElementsByClassName('animateLizardFollow')[0].style.display='none'
    }
    for (let i = 1; i < 9; i++) {
      await new Promise((resolve) =>
        setTimeout(
          resolve,
          (timing[i].timestamp - timing[i - 1].timestamp) * 1000
        )
      );
      if (count === 0) {
        setTimeout(() => {
          document.getElementsByClassName('circleDiv8')[3].style.display = 'none';
        }, 1500);
      } else {
        if (count === 1) {
          if(props.unit4){
            document.getElementById('rightHand').style.display =
            'none';
            document.getElementById('leftHand').style.display =
            'none';
          }
          context.activateClickDiv = false;
          setContext({ ...context });
        }
        document.getElementsByClassName('circleDiv8')[count - 1].style.display =
        'none';
      }

      setBirdFlying(true);
      ref.current.handleStart();
      document.getElementsByClassName('circleDiv8')[count].style.display =
        'block';
      if (count === 0) {
        if((round % 2) !== 0 && props.unit4){
          document.getElementById('rightHand').style.display =
          'block';
        }
        else if ((round % 2) === 0 && props.unit4){
          document.getElementById('leftHand').style.display =
          'block';
        }
        setTimeout(() => {
          if(!props.unit3 && !props.unit4) {
          }
          context.activateClickDiv = true;
          setContext({ ...context });
        }, 1500);
        setTimeout(() => {
          ref.current.handleStop();
          setBirdFlying(false);
        }, 1500);
      } else if (count === 1)  {
        if(!props.unit3 && !props.unit4) {
        }
        else lottieRef.current.anim.goToAndPlay(0, true);
        setTimeout(() => {
          ref.current.handleStop();
          setBirdFlying(false);
        }, 1500);
      } else if (count === 2) {
        if(!props.unit3 && !props.unit4) {
        }
        else lottieRef.current.anim.goToAndPlay(0, true);
        setTimeout(() => {
          ref.current.handleStop();
          setBirdFlying(false);
        }, 1500);
      } else if (count === 3) {
        if(!props.unit3 && !props.unit4) {
        }
        else lottieRef.current.anim.goToAndPlay(0, true);
        setTimeout(() => {
          ref.current.handleStop();
          setBirdFlying(false);
        }, 800);
      } 
      count += 1;
      if (count === 4) {
        round += 1;
        count = 0;
      }
    }
    document.getElementById('rightHand').style.display =
    'none';
    document.getElementById('leftHand').style.display =
    'none';
  }

  async function leftrightHands(){
    document.getElementById('shrugLizard').style.display='block'
    document.getElementsByClassName('animateLizardFollow')[0].style.display='none'

    if(tutorial !== props.tutorial1_2){
      document.getElementById('rightHand').style.display =
      'none';
    }
    else{
      document.getElementById('leftHand').style.display =
      'none';
    }
    setTimeout(() => {
      document.getElementsByClassName('circleDiv8')[1].style.display =
    'block';
      setBirdFlying(true);
      ref.current.handleStart();
    }, 500);
    setTimeout(() => {
      lottieRef.current.anim.goToAndPlay(0, true);
    }, 1000);
    await new Promise((resolve) => setTimeout(resolve, 2 * 1000));
    setBirdFlying(false);
    ref.current.handleStop();
    document.getElementsByClassName('circleDiv8')[1].style.display =
    'none';
    setTimeout(() => {
      document.getElementsByClassName('circleDiv8')[2].style.display =
      'block';
      setBirdFlying(true);
      ref.current.handleStart();
    }, 500);
    setTimeout(() => {
      lottieRef.current.anim.goToAndPlay(0, true);
    }, 1000);
    await new Promise((resolve) => setTimeout(resolve, 2 * 1000));
    setBirdFlying(false);
    ref.current.handleStop();
    document.getElementsByClassName('circleDiv8')[2].style.display =
    'none';
    setTimeout(() => {
      document.getElementsByClassName('circleDiv8')[3].style.display =
      'block';
      setBirdFlying(true);
      ref.current.handleStart();
    }, 500);
    setTimeout(() => {
      lottieRef.current.anim.goToAndPlay(0, true);
    }, 1000);
    await new Promise((resolve) => setTimeout(resolve, 2 * 1000));
    setBirdFlying(false);
    ref.current.handleStop();
    document.getElementsByClassName('circleDiv8')[3].style.display =
    'none';
    if(tutorial !== props.tutorial1_2){
      setTutorial(props.tutorial1_2)
      context.startedTutorial = true;
      setContext({ ...context });
    }
    else{
      context.startedTutorial2 = true;
      setContext({ ...context });
    }
  }

  // Initially starts FTB with or without the tutorial based on what day we're at
  function controllerStart() {
    if (props.module.unlockedDays.day2 || login.grade === "Teacher Mode" || login.grade === "Free Play") {
      setPlayInstructions(true);
      setAnimalVoice(props.instruction);
      setLizardState(props.instructionGIF);
      setShowAnimal(true);
      context.finishedTutorial = true;
      setContext({ ...context });
    } else {
      setSong(props.walkthrough);
      context.startedTutorial = true;
      setContext({ ...context });
    }
  }

  // A function that should be removed when the app is deployed, this allows us
  // as devs to skip the entirity of FTB.
  function SkipBubbles() {
    setPlaySong(false);
    if (!props.module.reviewIcon) {
      dispatch({ type: props.stepComplete, payload: 'followthebeat' });
    }
    props.setDisplayFTB(false);
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // ==================== iOS Detection ====================
  const isIOS = () => {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  useEffect(() => {
    let timer;
    if(displayVoice && isIOS()) {
      timer = setTimeout(() => {
        setAudioReady(false);
        setDisplayVoice(false);
        setShowAnimal(false);
        if (playInstructions) {
          setPlayInstructions(false);
          togglePopup();
        }
        if (playAwesomeJob) {
          updateScore();
          if (!props.module.reviewIcon) {
            dispatch({
              type: props.stepComplete,
              payload: 'followthebeat',
            });
          }
          props.module.sectionCompleted = props.module.sectionCompleted + 1
          props.setDisplayFTB(false);
        }
      }, 10000);
    }
    return () => {
      if(timer) clearTimeout(timer);
    }
  }, [displayVoice]);

  return (
    <>
      {displayVoice && (
        <audio
          autoPlay
          onPlay={() => {
            setAudioReady(true);
          }}
          onEnded={() => {
            setAudioReady(false);
            setDisplayVoice(false);
            setShowAnimal(false);
            if (playInstructions) {
              setPlayInstructions(false);
              setPlaySong(true);
            }
            if (playAwesomeJob) {
              updateScore();
              if (!props.module.reviewIcon) {
                dispatch({
                  type: props.stepComplete,
                  payload: 'followthebeat',
                });
              }
              props.module.sectionCompleted = props.module.sectionCompleted + 1
              props.setDisplayFTB(false);
            }
          }}
        >
          <source src={animalVoice}></source>
        </audio>
      )}

      <div
        id='FollowTheBeatBody8'
        style={{
          backgroundImage: `url(${
            generateImageUrl('images/Module8Images/FTB%20Module%208-1.png')
          })`,
        }}
      >
        {(!window.location.href.includes('wearefriends.cool') ? true : window.location.href.includes('staging') ? true : false ) && <button type='button' onClick={SkipBubbles}>
          Skip The Bubbles
        </button>}
        {isOpen && (
          <PopUp
            content={
              <>
                <b id='title'>
                  Ready to begin playing?
                  <br />
                </b>
                <button
                  id='logoutButton1'
                  className='logoutButton'
                  onClick={() => {
                    setCounting(false);
                    togglePopup();
                    setSong(props.song)
                    setPlaySong(true);
                    context.finishedTutorial = true;
                    setContext({ ...context });
                  }}
                >
                  START
                </button>
              </>
            }
            handleClose={togglePopup}
          />
        )}

        <div className='scoreBar'>
          <img className='scoreKey' src={coinBar} alt='lizard Icon' />
          {props.module.coins < 10 && (
            <h5 className='scoretext1'>{props.module.coins}</h5>
          )}
          {props.module.coins >= 10 && props.module.coins < 100 && (
            <h5 className='scoretext10'>{props.module.coins}</h5>
          )}
          {props.module.coins >= 100 && (
            <h5 className='scoretext100'>{props.module.coins}</h5>
          )}
          <p className='scoretext'>100</p>
        </div>

        {showCoin && (
          <img
            id={coinAnimationState}
            className='chooseReward'
            src={coin}
            alt='reward key'
            style={{
              position: 'absolute',
              top: '40vh',
              left: '50vw',
              width: '100px',
              height: '100px',
              marginLeft: '-50px',
              marginTop: '-50px',
            }}
            onClick={() => {
              coinAnimation();
            }}
          ></img>
        )}

        <img
          className='back-btn-ftb'
          alt='back button'
          src={Exit}
          onClick={() => {
            props.setDisplayFTB(false);
          }}
        ></img>

        <div className='lottieLizard' id='shrugLizard' style={{display: 'none'}}>
          <LottieAnimation
            ref={lottieRef}
            jsonUrl="appfiles/change_feelings/lizard_shrug.json"
            onAnimationComplete={() => console.log('completed')}
            login={login}

          />
        </div>
        <img className='animateLizardFollow' src={lizard} alt='lizard Icon' />
        {showAnimal && !audioReady && <img id='loading' src={loading} />}
        {showAnimal && (
          <img
            className='animateLizardFollowGIF'
            style={audioReady ? {} : { display: 'none' }}
            src={lizardState}
            onLoad={() => {
              setDisplayVoice(true);
            }}
            onError={() => setShowAnimal(false)}
          />
        )}
        {!isOpen && (
          <img
            className='animateLizardFollowGIF'
            src={CountingGif}
            style={counting ? { display: 'block' } : { display: 'none' }}
          />
        )}

        <img className='nest' src={nest} alt='nest Icon' />
        <img
          id='flyingDino1'
          className='flyingDino'
          src={flyingDino}
          alt='flying dino Icon'
        />
        <img
          id='flyingDino2'
          className='flyingDino'
          src={flyingDino}
          alt='flying dino Icon'
        />
        <img
          id='flyingDino3'
          className='flyingDino'
          src={flyingDino}
          alt='flying dino Icon'
        />
        <img
          id='flyingDino4'
          className='flyingDino'
          src={flyingDino}
          alt='flying dino Icon'
        />
        <div style={birdFlyng ? { display: 'block' } : { display: 'none' }}>
          <ReactAnimateImages
            className='birdAnimation'
            style={{ heigth: '250px', width: '250px' }}
            ref={ref}
            images={flyingBird}
            framInterval={200}
            stopAfterFirstRound={true}
          />
        </div>

        <div id='clickCircle8' />
        <img src={left} id='leftHand' alt='left hand'/>
        <img src={right} id='rightHand' alt='right hand'/>
        {context.activateClickDiv ? (
          <div
            id='timedCircle8'
            onClick={function () {
              if (context.finishedTutorial) {setScore(score + 1);}
              if (context.finishedTutorial || context.startedTutorial2) {
                setCoinAnimationState('coinAnimation');
                setShowCoin(true);
                sleep(1000).then(() => {
                  setShowCoin(false);
                  increaseCoins();
                  setCoinAnimationState('');
                });
              } else {
                context.activateClickDiv = false;
                if (props.unit4){
                  leftrightHands();
                }
                else{
                  context.startedTutorial2 = true;
                }
                setBirdFlying(false);
                ref.current.handleStop();
                document.getElementsByClassName('circleDiv8')[0].style.display =
                  'none';
                setContext({ ...context });
              }
              context.activateClickDiv = false;
              setContext({ ...context });
            }}
          ></div>
        ) : (
          <></>
        )}
        <div
          id='circleEgg1'
          className='circleDiv8'
          style={{
            backgroundImage: `url(${
              generateImageUrl('images/Module8Images/Unit2_Mod3_FTB_GoldDinoEgg@2x.png')
            })`,
          }}
        ></div>
        <div
          id='circleEgg2'
          className='circleDiv8'
          style={{
            backgroundImage: `url(${
              generateImageUrl('images/Module8Images/Unit2_Mod3_FTB_BlueDinoEgg2@2x.png')
            })`,
          }}
        ></div>
        <div
          id='circleEgg3'
          className='circleDiv8'
          style={{
            backgroundImage: `url(${
              generateImageUrl('images/Module8Images/Unit2_Mod3_FTB_BlueDinoEgg3@2x.png')
            })`,
          }}
        ></div>
        <div
          id='circleEgg4'
          className='circleDiv8'
          style={{
            backgroundImage: `url(${
              generateImageUrl('images/Module8Images/Unit2_Mod3_FTB_BlueDinoEgg4@2x.png')
            })`,
          }}
        ></div>
      </div>
      <audio
        ref={musicAudioRef}
        src={musicSrc}
        preload='auto'
        playsInline
        onLoadedData={() => {
          const el = musicAudioRef.current;
          if (!el) return;
          if (!musicShouldPlay) return;
          el.currentTime = 0;
          el.play().then(() => {
            const onPlayAction = musicOnPlayActionRef.current;
            if (typeof onPlayAction === 'function') onPlayAction();
          }).catch(() => {});
        }}
        onEnded={() => {
          const action = musicEndActionRef.current;
          musicEndActionRef.current = null;
          setMusicShouldPlay(false);
          if (typeof action === 'function') action();
        }}
      />
    </>
  );
};
export default FollowTheBeatModule8;
